import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

const planVacio = {
  nombre: '', descripcion: '', precio: 0, ciclo: 'mensual',
  maxNumeros: 1, maxAgentes: 1, maxContactos: 1000, maxMensajesMes: 5000, maxCampanasMes: 0,
  permiteCampanasMasivas: false, permitePlantillas: false, permiteFlujosBot: false,
  permiteAPI: false, permiteWebhooks: false, permiteIA: true,
  permitePipelines: true, permiteReportes: true,
  visible: true, destacado: false,
}

export default function AdminPlanes() {
  const [planes, setPlanes] = useState([])
  const [editando, setEditando] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [form, setForm] = useState(planVacio)

  const cargar = async () => { const { data } = await api.get('/admin/sa/planes'); setPlanes(data) }
  useEffect(() => { cargar() }, [])

  const guardar = async (e) => {
    e.preventDefault()
    try {
      if (editando) await api.put(`/admin/sa/planes/${editando.id}`, form)
      else await api.post('/admin/sa/planes', form)
      toast.success('Guardado')
      setShowModal(false); setEditando(null); setForm(planVacio)
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este plan?')) return
    await api.delete(`/admin/sa/planes/${id}`); cargar()
  }

  const editar = (p) => { setEditando(p); setForm(p); setShowModal(true) }
  const nuevo = () => { setEditando(null); setForm(planVacio); setShowModal(true) }

  const upd = (k, v) => setForm(prev => ({ ...prev, [k]: v }))

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <h1 className="text-2xl font-bold">💰 Planes de suscripción</h1>
        <button className="btn btn-primary" onClick={nuevo}>+ Nuevo plan</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {planes.map(p => (
          <div key={p.id} className="card" style={p.destacado ? { borderColor: 'var(--primary)', boxShadow: '0 0 0 2px var(--primary)' } : {}}>
            {p.destacado && <span className="badge badge-primary">⭐ Destacado</span>}
            <h3 className="text-xl font-bold" style={{ marginTop: 6 }}>{p.nombre}</h3>
            <div className="text-2xl font-bold" style={{ color: 'var(--primary)' }}>${p.precio}<span className="text-sm text-muted">/{p.ciclo}</span></div>
            <p className="text-sm text-muted" style={{ marginTop: 4, marginBottom: 12 }}>{p.descripcion}</p>

            <div className="flex flex-col gap-1 text-sm" style={{ marginBottom: 12 }}>
              <div>📱 {p.maxNumeros} números</div>
              <div>🧑 {p.maxAgentes} agentes</div>
              <div>👥 {p.maxContactos.toLocaleString()} contactos</div>
              <div>💬 {p.maxMensajesMes.toLocaleString()} mensajes/mes</div>
              <div>📢 {p.maxCampanasMes} campañas/mes</div>
            </div>

            <div className="flex flex-col gap-1 text-sm" style={{ marginBottom: 14 }}>
              {p.permiteCampanasMasivas && <div>✅ Campañas masivas</div>}
              {p.permitePlantillas && <div>✅ Plantillas</div>}
              {p.permiteFlujosBot && <div>✅ Flujos de bot</div>}
              {p.permiteWebhooks && <div>✅ Webhooks</div>}
              {p.permiteAPI && <div>✅ API pública</div>}
            </div>

            <div className="flex gap-2">
              <button className="btn btn-sm btn-outline" onClick={() => editar(p)}>✏️ Editar</button>
              <button className="btn btn-sm btn-danger" onClick={() => eliminar(p.id)}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editando ? 'Editar' : 'Nuevo'} plan</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div className="modal-body">
                <div className="flex gap-3">
                  <div className="form-group flex-1"><label className="form-label">Nombre</label><input className="input" required value={form.nombre} onChange={e => upd('nombre', e.target.value)} /></div>
                  <div className="form-group" style={{ width: 120 }}><label className="form-label">Precio</label><input type="number" step="0.01" className="input" required value={form.precio} onChange={e => upd('precio', parseFloat(e.target.value))} /></div>
                  <div className="form-group" style={{ width: 120 }}>
                    <label className="form-label">Ciclo</label>
                    <select className="select" value={form.ciclo} onChange={e => upd('ciclo', e.target.value)}>
                      <option value="mensual">Mensual</option>
                      <option value="anual">Anual</option>
                    </select>
                  </div>
                </div>
                <div className="form-group"><label className="form-label">Descripción</label><input className="input" value={form.descripcion || ''} onChange={e => upd('descripcion', e.target.value)} /></div>

                <h4 style={{ margin: '14px 0 8px' }}>Límites</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8 }}>
                  <div className="form-group"><label className="form-label">Números</label><input type="number" className="input" value={form.maxNumeros} onChange={e => upd('maxNumeros', parseInt(e.target.value))} /></div>
                  <div className="form-group"><label className="form-label">Agentes</label><input type="number" className="input" value={form.maxAgentes} onChange={e => upd('maxAgentes', parseInt(e.target.value))} /></div>
                  <div className="form-group"><label className="form-label">Contactos</label><input type="number" className="input" value={form.maxContactos} onChange={e => upd('maxContactos', parseInt(e.target.value))} /></div>
                  <div className="form-group"><label className="form-label">Msgs/mes</label><input type="number" className="input" value={form.maxMensajesMes} onChange={e => upd('maxMensajesMes', parseInt(e.target.value))} /></div>
                  <div className="form-group"><label className="form-label">Campañas/mes</label><input type="number" className="input" value={form.maxCampanasMes} onChange={e => upd('maxCampanasMes', parseInt(e.target.value))} /></div>
                </div>

                <h4 style={{ margin: '14px 0 8px' }}>Funciones permitidas</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                  {[
                    ['permiteCampanasMasivas', 'Campañas masivas'],
                    ['permitePlantillas', 'Plantillas'],
                    ['permiteFlujosBot', 'Flujos de bot'],
                    ['permiteAPI', 'API pública'],
                    ['permiteWebhooks', 'Webhooks'],
                    ['permiteIA', 'Bot con IA'],
                    ['permitePipelines', 'Pipelines'],
                    ['permiteReportes', 'Reportes'],
                  ].map(([key, label]) => (
                    <label key={key} style={{ display: 'flex', gap: 8, cursor: 'pointer' }}>
                      <input type="checkbox" checked={!!form[key]} onChange={e => upd(key, e.target.checked)} />
                      {label}
                    </label>
                  ))}
                </div>

                <div style={{ marginTop: 14, display: 'flex', gap: 16 }}>
                  <label style={{ cursor: 'pointer' }}><input type="checkbox" checked={!!form.destacado} onChange={e => upd('destacado', e.target.checked)} /> Destacado ⭐</label>
                  <label style={{ cursor: 'pointer' }}><input type="checkbox" checked={!!form.visible} onChange={e => upd('visible', e.target.checked)} /> Visible públicamente</label>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
